import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  TableCell,
  TableRow,
  Typography,
  IconButton,
  Box,
} from "@mui/material";
import { Edit, Delete } from "@mui/icons-material";
import { CONSTANTS } from "../../../../library/common/constant";
import styles from "./list.module.scss";
import CustomDialog from "../../../../library/common/CustomDialog";
import { api } from "../../../../services";

import { throttle } from "lodash";

const { DELETE_CONFIRM_TITLE, DELETE_CONFIRM_MESSAGE, THROTTLE_DURATION } =
  CONSTANTS;

const RowItem = ({ item, getList }) => {
  const navigate = useNavigate();
  const [isDialogueOpen, setDialogueOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleOpenDeleteDialogue = () => {
    setDialogueOpen(true);
  };

  const handleCloseDeleteDialogue = () => {
    setDialogueOpen(false);
  };

  const handleDelete = throttle(async () => {
    try {
      setIsLoading(true);
      await api.delete(`/aboutus/${item?._id}`);
      await getList();
      handleCloseDeleteDialogue();
    } catch (error) {
      console.error("Failed to delete: ", error);
    } finally {
      setIsLoading(false);
    }
  }, THROTTLE_DURATION);

  return (
    <>
      {item && (
        <TableRow hover className={styles.tableRow}>
          <TableCell>
            <Box className={styles.imageBox}>
              {item?.isImage ? (
                <img
                  src={item?.cardImage}
                  alt={item?.heading?.en}
                  className={styles.image}
                />
              ) : (
                <video
                  width="500"
                  height="240"
                  controls
                  className={styles.image}
                >
                  <source src={item?.cardImage} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              )}
            </Box>
          </TableCell>
          <TableCell>
            <Typography className={styles.textSecondary}>
              {item?.heading?.en}
            </Typography>
          </TableCell>
          <TableCell>
            <Typography className={styles.textSecondaryWrap}>
              {item?.description?.en}
            </Typography>
          </TableCell>
          <TableCell>
            <div className={styles.urlContainer}>
              <Typography className={styles.urlText}>
                {item?.isImage ? "True" : "False"}
              </Typography>
            </div>
          </TableCell>
          <TableCell>
            <div className={styles.urlContainer}>
              <Typography className={styles.urlText}>
                {String(item?.order ? item?.order : 0)}
              </Typography>
            </div>
          </TableCell>
          <TableCell>
            <div className={styles.actions}>
              <IconButton
                size="small"
                color="primary"
                className={styles.iconButton}
                onClick={() => {
                  navigate(`/about-us/edit/${item?._id}`);
                }}
              >
                <Edit fontSize="small" />
              </IconButton>
              <IconButton
                size="small"
                color="error"
                className={styles.iconButton}
                onClick={handleOpenDeleteDialogue}
              >
                <Delete fontSize="small" />
              </IconButton>
            </div>
          </TableCell>
        </TableRow>
      )}

      <CustomDialog
        open={isDialogueOpen}
        title={DELETE_CONFIRM_TITLE}
        content={DELETE_CONFIRM_MESSAGE}
        onClose={handleCloseDeleteDialogue}
        onSecondaryClick={handleCloseDeleteDialogue}
        onPrimaryClick={handleDelete}
        disablePrimary={isLoading}
      />
    </>
  );
};

export default RowItem;
